import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

/**
 * 404 Not Found Page
 * Site-wide fallback for non-existent URLs
 */
const NotFound = () => {
  const history = useHistory();

  return (
    <>
      <Helmet>
        <title>Page Not Found | Elliot Koss</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Container style={{ paddingTop: '100px', paddingBottom: '2rem' }}>
        <Row className="justify-content-center text-center">
          <Col md={8} lg={6}>
            <h1 style={{ fontSize: '6rem', fontWeight: '700', color: '#dee2e6' }}>404</h1>
            <h2 className="mb-4">Page Not Found</h2>
            <p className="text-muted mb-4">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <Button
              variant="primary"
              onClick={() => history.push('/')}
              className="me-2"
            >
              Go Home
            </Button>
            <Button
              variant="outline-secondary"
              onClick={() => history.goBack()}
            >
              Go Back
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default NotFound;
